const selectAllCheckbox = () => {

    // Get the "Select All" checkbox
    const selectAllCheckbox = document.getElementById('selectAll');
    // Get all checkboxes (excluding the "Select All" checkbox)
    const checkboxes = document.querySelectorAll('.form input[type="checkbox"]');

    // Add a click event listener to the "Select All" checkbox
    if (selectAllCheckbox) {
        selectAllCheckbox.addEventListener('click', function () {

            // Set the state of all checkboxes based on the "Select All" checkbox
            checkboxes.forEach(function (checkbox) {
                checkbox.checked = selectAllCheckbox.checked;
                checkbox.dispatchEvent(new Event('change'));
            });
        });

        // Add click event listeners to individual checkboxes
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('click', function () {
                // If any checkbox is unchecked, uncheck the "Select All" checkbox
                selectAllCheckbox.checked = Array.from(checkboxes).every(function (checkbox) {
                    return checkbox.checked;
                });
            });
        });
    }
}

export { selectAllCheckbox };